import { Button, Col, Form, Input, Row, message } from 'antd';
import axios from 'axios';
import { useState } from 'react';
import Footer from '../component/Footer';
import { EnvironmentOutlined, MailOutlined, PhoneOutlined, SendOutlined } from '@ant-design/icons';

export default function Contact() {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const onSubmit = async (values) => {
        try {
            setLoading(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/contact/create`, values);
            message.success('Gửi liên hệ thành công! Chúng tôi sẽ phản hồi sớm nhất.');
            form.resetFields();
        } catch (error) {
            message.error('Gửi liên hệ thất bại, vui lòng thử lại!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="min-h-screen bg-gradient-to-b from-[#eef9ff] to-white">
                {/* Hero Section */}
                <div className="bg-gradient-to-r from-[#1e90ff] to-[#0e4a61] text-white py-16">
                    <div className="max-w-screen-xl mx-auto px-6 text-center">
                        <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Liên Hệ Với Chúng Tôi</h1>
                        <p className="text-lg text-blue-100 max-w-2xl mx-auto">Hãy để lại thông tin, chúng tôi sẽ hỗ trợ bạn trong thời gian sớm nhất có thể</p>
                    </div>
                </div>

                <div className="max-w-screen-xl mx-auto px-6 py-12">
                    <Row gutter={[40, 40]}>
                        {/* Contact Info */}
                        <Col xs={24} md={10}>
                            <div className="space-y-6">
                                <h2 className="text-2xl font-bold text-gray-800 mb-6">Thông tin liên hệ</h2>
                                
                                <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
                                            <PhoneOutlined className="text-xl text-blue-600" />
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Hotline</p>
                                            <p className="text-lg font-semibold text-gray-800">+84 829 100 363</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                                            <MailOutlined className="text-xl text-green-600" />
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Email</p>
                                            <p className="text-lg font-semibold text-gray-800">effortlessenglishcontact@gmail.com</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
                                            <EnvironmentOutlined className="text-xl text-orange-600" />
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Địa chỉ</p>
                                            <p className="text-lg font-semibold text-gray-800">Hà Nội, Việt Nam</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl shadow-lg p-6 text-white">
                                    <h3 className="text-lg font-bold mb-2">Giờ làm việc</h3>
                                    <p className="text-blue-100">Thứ 2 - Thứ 6: 8:00 - 17:00</p>
                                    <p className="text-blue-100">Thứ 7: 8:00 - 12:00</p>
                                    <p className="text-blue-100">Chủ nhật: Nghỉ</p>
                                </div>
                            </div>
                        </Col>

                        {/* Contact Form */}
                        <Col xs={24} md={14}>
                            <div className="bg-white rounded-2xl shadow-xl p-8">
                                <h2 className="text-2xl font-bold text-gray-800 mb-6">Gửi tin nhắn cho chúng tôi</h2>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onSubmit}
                                    size="large"
                                >
                                    <Row gutter={16}>
                                        <Col xs={24} md={12}>
                                            <Form.Item 
                                                name="name" 
                                                label="Họ và tên"
                                                rules={[{ required: true, message: 'Vui lòng nhập họ tên!' }]}
                                            >
                                                <Input placeholder="Nguyễn Văn A" className="rounded-lg" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={12}>
                                            <Form.Item 
                                                name="email" 
                                                label="Email"
                                                rules={[{ type: 'email', message: 'Email không hợp lệ!' }]}
                                            >
                                                <Input placeholder="email@example.com" className="rounded-lg" />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Form.Item name="phone" label="Số điện thoại">
                                        <Input placeholder="0901234567" className="rounded-lg" />
                                    </Form.Item>
                                    <Form.Item 
                                        name="message" 
                                        label="Nội dung"
                                        rules={[{ required: true, message: 'Vui lòng nhập nội dung!' }]}
                                    >
                                        <Input.TextArea rows={5} placeholder="Nội dung tin nhắn..." className="rounded-lg" />
                                    </Form.Item>
                                    <Button 
                                        type="primary" 
                                        htmlType="submit" 
                                        loading={loading}
                                        icon={<SendOutlined />}
                                        className="bg-blue-500 hover:bg-blue-600 h-12 px-8 rounded-lg text-lg font-semibold"
                                    >
                                        Gửi tin nhắn
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
            <Footer />
        </>
    );
}
